import { useCallback, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { ConfigProvider, Tabs } from 'antd';

import { useSelector } from "react-redux";
import EmployeeInfoContactInfo from "../pages/EmployeeInfoContactInfo";
import EmployeeInfoEducation from "../pages/EmployeeInfoEducation";
import EmployeeInfoFamily from "../pages/EmployeeInfoFamily";
import EmployeeInfoGeneralInfo from "../pages/EmployeeInfoGeneralInfo";
import EmployeeInfoWorkExperience from "../pages/EmployeeInfoWorkExperience";
import { EMPLOYEE_INFO_PAGE, PERMISSIONS_CONFIG } from "../schemas/employeeInfoSchema";
function getItem(rules, i18n_key, label, key, icon, children, type) {
  return {
    rules,
    i18n_key,
    key,
    icon,
    children,
    label,
    type,
  };
}

const EMPLOYEE_INFO_MENU = [
  getItem(
    EMPLOYEE_INFO_PAGE.GENERAL_INFO,
    "General Info",
    EMPLOYEE_INFO_PAGE.GENERAL_INFO
    // <CopyOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_INFO_PAGE.CONTACT_INFO,
    "Contact Info",
    EMPLOYEE_INFO_PAGE.CONTACT_INFO
    // <CalendarOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_INFO_PAGE.FAMILY,
    "Family",
    EMPLOYEE_INFO_PAGE.FAMILY
    // <CopyOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_INFO_PAGE.WORK_EXPERIENCE,
    "Work Experience",
    EMPLOYEE_INFO_PAGE.WORK_EXPERIENCE
    // <CopyOutlined style={{ color: "gray" }} />
  ),
  getItem(
    EMPLOYEE_INFO_PAGE.EDUCATION,
    "Education",
    EMPLOYEE_INFO_PAGE.EDUCATION
    // <CopyOutlined style={{ color: "gray" }} />
  ),
];

function EmployeeInfoMenu({ className = "", onChange = () => { } }) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [permissions, setPermissions] = useState({})

  const getFirstAvailableTab = useCallback(() => {
    const tabPermissions = [
      { key: EMPLOYEE_INFO_PAGE.GENERAL_INFO, permission: "ACCESS_EMPLOYEE|EMPLOYEE_INFO|GENERAL_INFO" },
      { key: EMPLOYEE_INFO_PAGE.CONTACT_INFO, permission: "ACCESS_EMPLOYEE|EMPLOYEE_INFO|CONTACT_INFO" },
      { key: EMPLOYEE_INFO_PAGE.FAMILY, permission: "ACCESS_EMPLOYEE|EMPLOYEE_INFO|FAMILY" },
      { key: EMPLOYEE_INFO_PAGE.WORK_EXPERIENCE, permission: "ACCESS_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE" },
      { key: EMPLOYEE_INFO_PAGE.EDUCATION, permission: "ACCESS_EMPLOYEE|EMPLOYEE_INFO|EDUCATION" }
    ];

    for (const tab of tabPermissions) {
      if (roles.includes(tab.permission)) {
        return tab.key;
      }
    }
    return EMPLOYEE_INFO_PAGE.GENERAL_INFO;
  }, [roles]);

  const [selectedKeys, setSelectedKeys] = useState(getFirstAvailableTab());

  // const onMenuClick = (e) => {
  //   const key = e.key;
  //   setSelectedKeys([key]);
  //   onChange(key);
  // };

  const getPermissions = (menu) => {
    const permissions = PERMISSIONS_CONFIG[menu] || {};
    return Object.keys(permissions).reduce((acc, perm) => {
      acc[perm] = roles.includes(permissions[perm]);
      return acc;
    }, {});
  };

  useEffect(() => {
    const newPermissions = getPermissions(selectedKeys);
    setPermissions(newPermissions);
  }, [selectedKeys, roles]);

  const onMenuClick = (activeKey) => {
    setSelectedKeys(activeKey);
    onChange(activeKey);
  };

  useEffect(() => {
    const firstAvailableTab = getFirstAvailableTab();
    setSelectedKeys(firstAvailableTab);
  }, [roles, getFirstAvailableTab]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemHoverColor: "var(--tab-color)",
            itemActiveColor: "var(--tab-color)"
          },
        },
      }}
    >
      <Tabs activeKey={selectedKeys} onChange={onMenuClick} tabBarStyle={{ justifyContent: 'space-between' }} destroyInactiveTabPane={false}>
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYEE_INFO|GENERAL_INFO") &&
          <Tabs.TabPane tab={t('tab.menu.label.general_info')} key={EMPLOYEE_INFO_PAGE.GENERAL_INFO}>
            <EmployeeInfoGeneralInfo permissions={permissions} />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYEE_INFO|CONTACT_INFO") && <Tabs.TabPane tab={t('tab.menu.label..contact-info')} key={[EMPLOYEE_INFO_PAGE.CONTACT_INFO]} >
            <EmployeeInfoContactInfo permissions={permissions} />
          </Tabs.TabPane>
        }

        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYEE_INFO|FAMILY") && <Tabs.TabPane tab={t('tab.menu.label.family')} key={[EMPLOYEE_INFO_PAGE.FAMILY]} >
            <EmployeeInfoFamily permissions={permissions} />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE") && <Tabs.TabPane tab={t('tab.menu.label.work-experience')} key={[EMPLOYEE_INFO_PAGE.WORK_EXPERIENCE]} >
            <EmployeeInfoWorkExperience permissions={permissions} />
          </Tabs.TabPane>
        }
        {
          roles.includes("ACCESS_EMPLOYEE|EMPLOYEE_INFO|EDUCATION") && <Tabs.TabPane tab={t('tab.menu.label.education')} key={[EMPLOYEE_INFO_PAGE.EDUCATION]} >
            <EmployeeInfoEducation permissions={permissions} />
          </Tabs.TabPane>
        }
      </Tabs>
    </ConfigProvider>
  );
}

export default EmployeeInfoMenu;
